import React, { useEffect } from "react";
import { indexStore } from "src/store/indexStore";
import Iterator from "../../utils/Iterator";
import { useTranslation } from "react-i18next";
import { Button } from "../../ui/button";
import AddUserModel from "./AddUserModel";
import { UserCard, UserCardLoading } from "src/Components/Cards/UserCard";
import Visibility from "src/Components/utils/Visibility";
import { Users as UsersIcon, UserPlus, UserRoundX } from "lucide-react";

function Users() {
  const {
    fetchUsersFunction,
    users,
    branches,
    featchBranchesFunction,
    usersLoading,
  } = indexStore();
  const { t } = useTranslation();

  useEffect(() => {
    if (branches.length === 0) featchBranchesFunction();
    fetchUsersFunction();
  }, [featchBranchesFunction, fetchUsersFunction, branches.length]);

  return (
    <div className="flex flex-col gap-6">
      {/* Header Section */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div className="flex items-center gap-3">
          <div className="p-3 rounded-lg bg-gradient-to-br from-primary/10 to-transparent border">
            <UsersIcon className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-foreground">{t("gloabl.users")}</h2>
            <p className="text-sm text-muted-foreground">
              {t("gloabl.manage_users") || "View and manage system users"}
            </p>
          </div>
        </div>
        <AddUserModel
          trigger={
            <Button size="lg" className="gap-2">
              <UserPlus className="w-4 h-4" />
              {t("gloabl.add")} {t("gloabl.user")}
            </Button>
          }
        />
      </div>

      {/* Users Grid */}
      <div className="flex-1">
        <Visibility visible={!usersLoading && users.length > 0}>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <UsersIcon className="w-5 h-5 text-primary" />
                <h3 className="text-lg font-semibold">
                  {t("gloabl.users_found") || "Users"} ({users.length})
                </h3>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              <Iterator data={users} render={(e, i) => <UserCard {...e} key={e.id || i} />} />
            </div>
          </div>
        </Visibility>

        <Visibility visible={usersLoading}>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            <Iterator
              data={[1, 2, 3, 4, 5, 6]}
              render={(e, i) => <UserCardLoading key={i} />}
            />
          </div>
        </Visibility>

        <Visibility visible={!usersLoading && users.length === 0}>
          <div className="flex flex-col items-center justify-center py-12 text-center text-muted-foreground">
            <UserRoundX className="w-16 h-16 mb-4 text-gray-300" />
            <p className="text-xl font-semibold mb-2">{t("gloabl.no_users_found") || "No users found"}</p>
            <p className="mb-4">{t("gloabl.no_users_description") || "Create your first user to get started"}</p>
            <AddUserModel
              trigger={
                <Button size="lg" className="gap-2">
                  <UserPlus className="w-4 h-4" />
                  {t("gloabl.add")} {t("gloabl.user")}
                </Button>
              }
            />
          </div>
        </Visibility>
      </div>
    </div>
  );
}

export default Users;
